export const NAMESPACE = 'KanBo/previousBlockedCards/'
export const ADD = NAMESPACE + 'ADD'
export const SET_ARRAY = NAMESPACE + 'SET_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {}

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.cardId]: Array.from(new Set<number>(state[action.payload.cardId]).add(action.payload.previousCardId)),
      }
    case SET_ARRAY:
      return {
        ...state,
        [action.payload.cardId]: Array.from(new Set<number>(action.payload.previousCardIds)),
      }
    case REMOVE:
      return state[action.payload.cardId]?.includes(action.payload.previousCardId) ? {
        ...state,
        [action.payload.cardId]: state[action.payload.cardId].filter(id => id !== action.payload.previousCardId),
      } : state
    default: return state
  }
}

export function add ({ cardId, previousCardId }) {
  return {
    type: ADD,
    payload: {
      cardId,
      previousCardId,
    }
  }
}

export function setArray ({ cardId, previousCardIds }) {
  return {
    type: SET_ARRAY,
    payload: {
      cardId,
      previousCardIds,
    }
  }
}

export function remove ({ cardId, previousCardId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      previousCardId,
    }
  }
}
